/**
 * Same rules as Object Manager’s object list: entitlements allowlist for standard objects,
 * allow_explore on object config, and deleted rows excluded.
 */
import { getEntitlementsSection, canAccessSetup } from './entitlements';

/** Resolve allow_explore from config, with schema/tenant override. */
export const getEffectiveAllowExplore = (config, schemaOrTenantKey) => {
  if (!config || typeof config !== 'object') return true;
  const base = config?.allow_explore;
  const override =
    schemaOrTenantKey &&
    config[schemaOrTenantKey] &&
    typeof config[schemaOrTenantKey] === 'object' &&
    Object.prototype.hasOwnProperty.call(config[schemaOrTenantKey], 'allow_explore')
      ? config[schemaOrTenantKey].allow_explore
      : undefined;
  const value = override !== undefined ? override : base;
  return !(value === false || value === 'false' || value === 0 || value === '0');
};

const parseObjectConfig = (rawConfig) => {
  if (!rawConfig) return {};
  if (typeof rawConfig === 'string') {
    try {
      const parsed = JSON.parse(rawConfig);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }
  return typeof rawConfig === 'object' ? rawConfig : {};
};

/**
 * @param {Array<object>} objectsWithFields - rows from objectconfig fetchAll
 * @returns {Array<object>} same shape, filtered
 */
export function filterObjectManagerAllowedObjects(objectsWithFields) {
  if (!Array.isArray(objectsWithFields)) {
    return [];
  }

  const objectManagerConfig = getEntitlementsSection('objectManager', {});
  const allowedStandardObjects = new Set(
    (objectManagerConfig?.allowedObjects || []).map((name) => String(name).toLowerCase())
  );
  const restrictStandardObjects =
    objectManagerConfig?.mode === 'allowlist' &&
    objectManagerConfig?.scope === 'standard' &&
    allowedStandardObjects.size > 0;

  const schemaOrTenantKey =
    typeof localStorage !== 'undefined' ? localStorage.getItem('tenantcode') || undefined : undefined;

  const canExploreObject = (obj) => {
    const config = parseObjectConfig(obj?.config);
    return getEffectiveAllowExplore(config, schemaOrTenantKey);
  };

  const isObjectAllowed = (obj) => {
    const nameLc = String(obj?.object_name || '').toLowerCase();
    if (nameLc === 'user' && canAccessSetup()) {
      return true;
    }
    if (!restrictStandardObjects) {
      return true;
    }
    if (!obj?.is_standard) {
      return true;
    }
    return allowedStandardObjects.has(nameLc);
  };

  return objectsWithFields
    .filter((obj) => !obj.is_deleted)
    .filter(isObjectAllowed)
    .filter(canExploreObject);
}
